import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  propertyStatuses: null,
  dwellingTypes: null,
  counties: null,
  cities: null,
  zipCodes: null,
  houseSquareFeet: null,
  lotSquareFeet: null,
  daysSinceListed: null,
  prices: null,
  propertyHighlight: null,
  navigation: [],
  contactTags: [],
  buyerFinancing: null,
  cooling: null,
  diningArea: null,
  elementarySchool: null,
  elementarySchoolDistrict: null,
  heating: null,
  highSchool: null,
  highSchoolDistrict: null,
  middleOrJuniorSchool: null,
  otherRooms: null,
  solarPanelsOwnership: null,
  ownerIntendUse: null,
  featureFlags: {
    valuations: { enabled: false },
    daysOnCurbViewFilter: { enabled: false }
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROPERTY_STATUSES:
      return {
        ...state,
        propertyStatuses: action.statuses
      }
    case actionTypes.SET_DWELLING_TYPES:
      return {
        ...state,
        dwellingTypes: action.dwellingTypes
      }
    case actionTypes.SET_COUNTIES:
      return {
        ...state,
        counties: action.counties
      }
    case actionTypes.SET_CITIES:
      return {
        ...state,
        cities: action.cities
      }
    case actionTypes.SET_ZIP_CODES:
      return {
        ...state,
        zipCodes: action.zipCodes
      }
    case actionTypes.SET_HOUSE_SQUARE_FEET:
      return {
        ...state,
        houseSquareFeet: action.houseSquareFeet
      }
    case actionTypes.SET_LOT_SQUARE_FEET:
      return {
        ...state,
        lotSquareFeet: action.lotSquareFeet
      }
    case actionTypes.SET_DAYS_SINCE_LISTED:
      return {
        ...state,
        daysSinceListed: action.daysSinceListed
      }
    case actionTypes.SET_PRICES:
      return {
        ...state,
        prices: action.prices
      }
    case actionTypes.SET_PROPERTY_HIGHLIGHT:
      return {
        ...state,
        propertyHighlight: action.markerId
      }
    case actionTypes.SET_NAVIGATION:
      return {
        ...state,
        navigation: action.navigation
      }
    case actionTypes.SET_CONTACT_TAGS:
      return {
        ...state,
        contactTags: action.tags
      }
    case actionTypes.SET_SEARCH:
      return {
        ...state,
        ...action
      }
    case actionTypes.SET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.obj
      }
    default:
      return state
  }
}

export default reducer
